<template>
  <div class="proflist">
    <el-row :gutter="10">
      <el-col :span="8">
        <el-card class="box-card tablecard textLeft" shadow="never">
          <div slot="header" class="clearfix">
            <span><i class="fa fa-cogs fs14" /> Project Tree</span>
          </div>
          <div>
            <el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick" :highlight-current="ishilight"></el-tree>
          </div>
        </el-card>
      </el-col>
      <el-col :span="16">
        <el-card class="box-card tablecard textLeft" shadow="never">
          <div slot="header" class="clearfix">
            <span><i class="fa fa-cogs fs14" /> Data File</span>
            <el-button style="float: right; padding: 5px 10px" type="warning" icon="el-icon-download" @click.stop="handleBatchDownload" round>Http</el-button>
          </div>
          <div>
            Search: <el-input size="medium" v-model="searchkey" placeholder="" class="searchInput mr5" clearable></el-input>
            <el-button class="submitbtn" @click="handleSearch">Search</el-button>
            <el-table
              class="mt10"
              v-loading="loading"
              :row-key="getRowKey"
              empty-text="No Data"
              :data="dfileData"
              @sort-change="handleSort"
              @select="handleSelect"
              @select-all="handleSelect"
              border
              style="width: 100%">
              <el-table-column
                type="selection"
                :reserve-selection="true"
                width="55">
              </el-table-column>
              <el-table-column
                prop="file_name"
                label="File Name"
                :show-overflow-tooltip="isOverflow"
                sortable>
              </el-table-column>
              <el-table-column
                prop="file_type"
                label="File Type"
                :show-overflow-tooltip="isOverflow"
                sortable>
              </el-table-column>
              <el-table-column
                prop="fileSize"
                label="File Size"
                :show-overflow-tooltip="isOverflow"
                sortable>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              layout="total, prev, pager, next, jumper"
              :total="allNum"
              :page-size="pageSize"
              :current-page.sync="currentPage"
              @current-change="handleChangepage"
              class="pagination mb10">
            </el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <form :action="actionApi + downloadUrl" method="post" id="downForm" name="downForm">
      <!-- <input type="hidden" value="{proteinIdList: ['Q9Y2L6', 'Q9Y2D8', 'P19022']}" name="body"> -->
      <input type="hidden" value="" name="body" id="downVal">
      <!-- <button type="submit">111</button> -->
    </form>
  </div>
</template>

<script>
  import { getSearchSubProjectList, getProjectDataList, getSubProjectDataList, downloadDataFile } from '@/api'
  export default {
    name: 'proflist',
    data() {
      return {
        actionApi: 'http://10.1.22.29:10076/',
        downloadUrl: '/iprox/hfd/downloadDataFile',
        downVal: '',
        projectid: '',
        data: [{
          subproject_id: '',
          pro: 1,
          children: [{
            subproject_id: ''
          }]
        }],
        defaultProps: {
          children: 'children',
          label: 'subproject_id'
        },
        ajax_data_sublist: {
          search:{
            project_id: "",
            sub: ""
          },
          page:{
            startPage: 1,
            pageLength: 0
          },
          order:{
            item: "",
            type: ""
          }
        },
        loading: true,
        ajax_data_dfilep: {
          search:{
            project_id: "",
            sub: ""
          },
          page:{
            startPage: 1,
            pageLength: 10
          },
          order:{
            item: "",
            type: ""
          }
        },
        ajax_data_dfile: {
          search:{
            subproject_id: "",
            sub: ""
          },
          page:{
            startPage: 1,
            pageLength: 10
          },
          order:{
            item: "",
            type: ""
          }
        },
        dfileData: [],
        allNum: 0,
        pageSize: 10,
        currentPage: 1,
        multipleSelection: [],
        isOverflow: true,
        searchkey: '',
        isPro: 1,
        ishilight: true,
        orderConvert: {
          ascending: 'asc',
          descending: 'desc'
        },
        ajax_data_down: {
          'ids': []
        },
        downloadArr: []
      }
    },
    mounted() {
      this.projectid = this.$route.query.id
      this.ajax_data_sublist.search.project_id = this.$route.query.id
      getSearchSubProjectList(this.ajax_data_sublist).then(res => {
        let newData = res.result
        // let dataarr = [{project_id: 0}]
        // newData.forEach((val, index) => {
        //   let pid = val.subproject_id
        //   console.log(pid)
        //   dataarr[index].project_id = pid
        // })
        // console.log(dataarr)
        this.data[0].subproject_id = this.$route.query.id
        this.data[0].children = newData
      })
      this.loading = true
      this.ajax_data_dfilep.search.project_id = this.$route.query.id
      this.ajax_data_dfilep.search.sub = this.searchkey
      getProjectDataList(this.ajax_data_dfilep).then(res => {
        this.loading = false
        let newData = res.result
        newData.forEach((val, index) => {
          // let fileCount = val.file_count;
          let filesiz = this.handleFilesize(val.file_size)
          val.fileSize = filesiz
        })
        this.dfileData = newData
        this.allNum = res.count
      })
    },
    created() {
      // this.tableHeader = this.commonHeaders
    },
    methods: {
      handleNodeClick(data) {
        console.log(data);
        this.currentPage = 1
        if(data.pro && data.pro == 1) {
          this.isPro = 1
          this.loading = true
          this.ajax_data_dfilep.search.project_id = this.$route.query.id
          this.ajax_data_dfilep.search.sub = this.searchkey
          this.ajax_data_dfilep.page.startPage = 1
          getProjectDataList(this.ajax_data_dfilep).then(res => {
            this.loading = false
            let newData = res.result
            newData.forEach((val, index) => {
              // let fileCount = val.file_count;
              let filesiz = this.handleFilesize(val.file_size)
              val.fileSize = filesiz
            })
            this.dfileData = newData
            this.allNum = res.count
          })
        } else {
          this.isPro = 2
          this.loading = true
          this.ajax_data_dfile.search.subproject_id = data.subproject_id
          this.ajax_data_dfile.search.sub = this.searchkey
          this.ajax_data_dfile.page.startPage = 1
          getSubProjectDataList(this.ajax_data_dfile).then(res => {
            this.loading = false
            let newData = res.result
            newData.forEach((val, index) => {
              // let fileCount = val.file_count;
              let filesiz = this.handleFilesize(val.file_size)
              val.fileSize = filesiz
            })
            this.dfileData = newData
            this.allNum = res.count
          })
        }
      },
      handleChangepage (val) {
        if(this.isPro && this.isPro == 1) {
          this.loading = true
          this.ajax_data_dfilep.page.startPage = val
          getProjectDataList(this.ajax_data_dfilep).then(res => {
            this.loading = false
            let newData = res.result
            newData.forEach((val, index) => {
              // let fileCount = val.file_count;
              let filesiz = this.handleFilesize(val.file_size)
              val.fileSize = filesiz
            })
            this.dfileData = newData
            this.allNum = res.count
          })
        } else {
          this.loading = true
          this.ajax_data_dfile.page.startPage = val
          getSubProjectDataList(this.ajax_data_dfile).then(res => {
            this.loading = false
            let newData = res.result
            newData.forEach((val, index) => {
              // let fileCount = val.file_count;
              let filesiz = this.handleFilesize(val.file_size)
              val.fileSize = filesiz
            })
            this.dfileData = newData
            this.allNum = res.count
          })
        }
      },
      handleSort (column, prop, order) {
        // console.log(column, prop, order)
        if(this.isPro && this.isPro == 1) {
          this.loading = true
          this.ajax_data_dfilep.order.item = column.prop
          this.ajax_data_dfilep.order.type = this.orderConvert[column.order]
          if (column.order !== null && column.prop !== null) {
            getProjectDataList(this.ajax_data_dfilep).then(res => {
              this.loading = false
              let newData = res.result
              newData.forEach((val, index) => {
                // let fileCount = val.file_count;
                let filesiz = this.handleFilesize(val.file_size)
                val.fileSize = filesiz
              })
              this.dfileData = newData
              this.allNum = res.count
            })
          } else {
            this.loading = false
          }
        } else {
          this.loading = true
          this.ajax_data_dfile.order.item = column.prop
          this.ajax_data_dfile.order.type = this.orderConvert[column.order]
          if (column.order !== null && column.prop !== null) {
            getSubProjectDataList(this.ajax_data_dfile).then(res => {
              this.loading = false
              let newData = res.result
              newData.forEach((val, index) => {
                // let fileCount = val.file_count;
                let filesiz = this.handleFilesize(val.file_size)
                val.fileSize = filesiz
              })
              this.dfileData = newData
              this.allNum = res.count
            })
          } else {
            this.loading = false
          }
        }
      },
      handleSearch() {
        this.currentPage = 1
        if(this.isPro && this.isPro == 1) {
          this.loading = true
          this.ajax_data_dfilep.search.sub = this.searchkey
          this.ajax_data_dfilep.page.startPage = 1
          getProjectDataList(this.ajax_data_dfilep).then(res => {
            this.loading = false
            let newData = res.result
            newData.forEach((val, index) => {
              // let fileCount = val.file_count;
              let filesiz = this.handleFilesize(val.file_size)
              val.fileSize = filesiz
            })
            this.dfileData = newData
            this.allNum = res.count
          })
        } else {
          this.loading = true
          this.ajax_data_dfile.search.sub = this.searchkey
          this.ajax_data_dfile.page.startPage = 1
          getSubProjectDataList(this.ajax_data_dfile).then(res => {
            this.loading = false
            let newData = res.result
            newData.forEach((val, index) => {
              // let fileCount = val.file_count;
              let filesiz = this.handleFilesize(val.file_size)
              val.fileSize = filesiz
            })
            this.dfileData = newData
            this.allNum = res.count
          })
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        console.log(this.multipleSelection)
      },
      getRowKey (row) {
        return row.file_id
      },
      handleSelect (selection) {
        // console.log(selection)
        // let params = '{ids: ['
        // selection.map(item => {
        //   params += '"' + item.file_id + '",'
        // })
        // params += ']}'
        let uniprotIdArr = []
        selection.map(item => {
          uniprotIdArr.push(item.file_id)
        })
        // console.log(params)
        // selection.length === 0 ? this.downVal = '' : this.downVal = params
        this.downloadArr = uniprotIdArr
      },
      handleBatchDownload () {
        // console.log(this.downVal)
        if (this.downloadArr == []) {
          this.$message({
            message: 'Select nothing!',
            type: 'warning'
          })
        } else {
          // document.getElementById('downVal').value = this.downVal
          // document.getElementById('downForm').submit()
          this.ajax_data_down.ids = this.downloadArr
          downloadDataFile(this.ajax_data_down).then(res => {
            let fileData = res.result
            this.downloadFile(fileData,0)
            // fileData.map(item => {
            //   window.open(item.url)
            // })
          })
        }
      },
      // downloadFileList() {
      //     const resultList = [{
      //       "url": "https://download.iprox.cn/IPX0007905000/IPX0007905001/IPX0007905001.xml",
      //     }, {
      //       "url": "https://download.iprox.cn/IPX0007905000/IPX0007905000.xml",
      //     }]
      //   console.error(resultList)
      //   this.downloadFile(resultList,0)
      // },
      downloadFile(list, index) {
        if (index < list.length) {
            console.error('下载第'+index+'个')
          var hiddenIFrameID = 'hiddenDownloader' + index;
          var iframe = document.createElement('iframe');
          iframe.id = hiddenIFrameID;
          iframe.className = 'hiddenIFrameClass';
          iframe.style.display = 'none';
          document.body.appendChild(iframe);
          iframe.src = list[index].url;//直接下载，不会弹出新的页面
            setTimeout(() => {
                index += 1
                this.downloadFile(list, index)
            },1000)
        } else {
          const elements = document.querySelectorAll('.hiddenIFrameClass');  // 替换 className 为要删除元素的 class 名称
          elements.forEach(element => element.remove());
        }
      },
      handleFilesize(param) {
        let fileSize = new Number(param);
        if (fileSize == null) {
            fileSize=0;
        } else if (fileSize < 1024) {
            fileSize=fileSize.toFixed(2) + 'K';
        } else if (fileSize >= 1024 && fileSize < 1024 * 1024) {
            fileSize=(fileSize / 1024).toFixed(2) + 'M';
        } else {
            fileSize=(fileSize / 1024 / 1024).toFixed(2) + 'G';
        }
        return fileSize
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .proflist {
    
  }
</style>
